<template>
    <!-- Start Dummy -->
    <div v-if="!filteredEvents || filteredEvents.length == 0">
        <div class="list_event_card">
            <h3>Event tidak ditemukan</h3>
        </div>
    </div>
    <!-- End Dummy -->
    <!-- Start Api -->
    <div v-else>
        <div class="list_event_card">
            <div class="row-grid">
                <!-- Looping data event -->
                <div
                    class="col-grid-30"
                    v-for="(data, index) in filteredEvents"
                    :key="index"
                >
                    <div class="wrap-filter-racing">
                        <div class="schedule-racing-card  red">
                            <div class="schedule-card inline-flex">
                                <div class="schedule-date">
                                    <h3 class="tx-black">
                                        {{ data.date }}
                                    </h3>
                                </div>
                                <div class="schedule-details">
                                    <h3 class="schedule-title">
                                        {{
                                            data.name.length <= 30
                                                ? data.name
                                                : data.name.substring(0, 30) +
                                                  " ..."
                                        }}
                                    </h3>
                                    <span class="event-by"
                                        ><strong> {{
                                            data.dealer
                                                ? 'Event by ' + data.dealer
                                                : ''
                                        }}</strong></span
                                    >
                                    <div class="schedule-notif-share">
                                        <a  @click="trackerCheckEvent(data)"
                                            :href="data.detail_url_web"
                                            class="notifyme flex flex-center tx-red"
                                        >
                                            Check Event
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination">
            <Pagination :paging="eventData.paging" @goToPage="getAllData"></Pagination>
        </div>
    </div>
    <!-- End Api -->
</template>

<script>
import Pagination from "../../widget/Pagination";
export default {
    props: ["eventData",'selectedMonth','selectedProvince'],
    components: {
        Pagination
    },
    data() {
        return {
            mobile: false,
            isUserSimulate: false,
            user: {},
        };
    },
    computed: {
        filteredEvents() {
            return this.eventData.event.filter(data => {
                return (data.name !== 'Test Event Nasional' && data.name !== 'Test Event Regional') 
                    || (data.name === 'Test Event Nasional' && this.isUserSimulate) 
                    || (data.name === 'Test Event Regional' && this.isUserSimulate);
            });
        }
    },
    created() {
        // console.log(this.eventData);
        this.user = JSON.parse(localStorage.getItem("user"));
        this.checkUserSimulate();
    },
    methods: {
        getAllData(e){
            return this.$emit('getAllData', e)
        },
        trackerCheckEvent(data) {

            var tracker = {
                'event': 'checkEvent',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Check Event',
                'eventDetail.label': data.name,
                'eventType': data.type,
                'month': data.month || null,
                'province':  data.province || null
            }
                console.log(tracker);
            dataLayer.push(tracker)
        },
        checkUserSimulate() {
            const checkHcid = process.env.MIX_HCID_PAYMENT_TEST.split(",");
            if (this.user?.hcid !== undefined) {
                const user = this.user.hcid;
                if (checkHcid.includes(user.toString())) {
                    this.isUserSimulate = true;
                } else {
                    this.isUserSimulate = false;
                }
            } else {
                this.isUserSimulate = false;
            }

            console.log('isUserSimulate = ', this.isUserSimulate);
        },
    },
};
</script>

<style scoped lang="scss">
.schedule-card {
    display: inline-flex;
}
.schedule-racing-card {
    box-shadow: 8px 4px 25px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-bottom: 30px;
    background: #282828;
}
.btn-black {
    border: solid 1px #dbdbdb;
    border-radius: 10px;
}
.btn-grey {
    border: solid 1px #eee;
    border-radius: 10px;
    background-color: #eeeeee;
}
.schedule-racing-card:before {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    width: 20px;
    height: 100%;
    background-color: #dbdbdb;
}
.schedule-racing-card.red:before {
    background-color: #e61b33;
}
.schedule-racing-card.black:before {
    background-color: #282828;
}
.schedule-racing-card.grey:before {
    background-color: #dbdbdb;
}
.wrap-racing-schedule {
    margin-top: 2em;
}
.schedule-card {
    position: relative;
    padding: 2em;
}
.schedule-date {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #f8f8f8;
    border-radius: 10px;
    padding: 15px 25px;
    max-width: 105px;
}
.schedule-date h3 {
    text-align: center;
    font-weight: 600;
    margin: 0;
}
.schedule-details {
    margin-left: 15px;
    h3 {
        font-weight: 600;
        font-size: 20px;
        color: #ffffff;
        margin-bottom: 5px;
    }
    span {
        font-weight: 600;
        font-size: 12px;
        color: #4f4f4f;
        strong {
            color: #fff;
        }
    }
}
.schedule-notif-share a {
    display: inline-block;
}
.schedule-status {
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 10px;
    display: inline-block;
    font-weight: 600;
}
.schedule-location {
    font-weight: 600;
    margin: 15px 0 0;
}
.schedule-country {
    margin-top: 0;
    margin-bottom: 15px;
}
.notifyme {
    margin-top: 15px;
    background: none;
    border: 1px solid #686868;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 500;
    padding: 7px 14px;
    margin-right: 15px;
    color: #fff;
}
.notifyme:hover {
    color: #fff;
    background-color: #e61b33;
}
.notifyme span {
    margin-right: 5px;
    max-width: 12px;
    font-size: 16px;
}
.btn-schedule-racing {
    display: block;
    text-align: center;
    padding: 15px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
}
.shares {
    position: absolute;
    bottom: 40px;
    left: 0;
    height: 0;
    overflow: hidden;
    -webkit-transform-origin: top;
    transform-origin: top;
    -webkit-transition: -webkit-transform 0.4s ease-in-out;
    transition: -webkit-transform 0.4s ease-in-out;
    transition: transform 0.4s ease-in-out;
    transition: transform 0.4s ease-in-out, -webkit-transform 0.4s ease-in-out;
    a {
        margin: 2px 0;
    }
}
.active .shares {
    height: 115px;
}
.list_event_card .row-grid {
    flex-wrap: wrap;
}
</style>
